"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiButton = _interopRequireDefault(require("../HiButton"));
var styles = exports.styles = function styles(theme) {
  return {
    caption: (0, _objectSpread2.default)({
      display: 'table-caption',
      height: 40,
      textAlign: 'center',
      padding: '4px 0'
    }, theme.typography.body2, {
      color: theme.palette.neutral.main
    })
  };
};
var Caption = function Caption(_ref) {
  var classes = _ref.classes,
    date = _ref.date,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en_US' : _ref$locale,
    localeUtils = _ref.localeUtils,
    onMonthClick = _ref.onMonthClick,
    onYearClick = _ref.onYearClick;
  var months = localeUtils.getMonths(locale);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.caption
  }, /*#__PURE__*/_react.default.createElement(_HiButton.default, {
    size: "small",
    onClick: onMonthClick
  }, months[date.getMonth()]), /*#__PURE__*/_react.default.createElement(_HiButton.default, {
    size: "small",
    onClick: onYearClick
  }, date.getFullYear()));
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  name: 'HmuiCaption'
})(Caption);